interface HowToUseProps {
  onQuoteClick: () => void;
}

export default function HowToUse({ onQuoteClick }: HowToUseProps) {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            ご利用はとても簡単です
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">3ステップで完了</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div className="relative">
            <div className="hidden md:block absolute top-16 left-full w-full h-0.5 bg-blue-200 -translate-x-1/2 z-0">
              <div className="absolute right-0 top-1/2 -translate-y-1/2 w-3 h-3 flex items-center justify-center">
                <i className="ri-arrow-right-line text-blue-400"></i>
              </div>
            </div>
            
            <div className="relative bg-gradient-to-br from-blue-50 to-white p-8 rounded-2xl border-2 border-blue-100 hover:border-blue-300 transition-all hover:shadow-lg">
              <div className="text-5xl font-bold text-blue-200 mb-4">01</div>
              
              <div className="mb-6 rounded-xl overflow-hidden">
                <img 
                  src="https://www.inforesta.com/lp/image/35b75cc14fb60a5ef99bfca0e1d79150.jpg"
                  alt="欲しい論文情報をお送りください"
                  className="w-full h-48 object-cover object-top"
                />
              </div>
              
              <div className="w-14 h-14 flex items-center justify-center bg-blue-600 rounded-xl mb-4">
                <i className="ri-send-plane-line text-2xl text-white"></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                欲しい論文情報をお送りください
              </h3>
              <p className="text-gray-600">
                URLを貼るだけでもOKです。
              </p>
            </div>
          </div>
          
          <div className="relative">
            <div className="hidden md:block absolute top-16 left-full w-full h-0.5 bg-blue-200 -translate-x-1/2 z-0">
              <div className="absolute right-0 top-1/2 -translate-y-1/2 w-3 h-3 flex items-center justify-center">
                <i className="ri-arrow-right-line text-blue-400"></i>
              </div>
            </div>
            
            <div className="relative bg-gradient-to-br from-blue-50 to-white p-8 rounded-2xl border-2 border-blue-100 hover:border-blue-300 transition-all hover:shadow-lg">
              <div className="text-5xl font-bold text-blue-200 mb-4">02</div>
              
              <div className="mb-6 rounded-xl overflow-hidden">
                <img 
                  src="https://www.inforesta.com/lp/image/c7bd3bcec18df183124c7079340ac7ba.jpg"
                  alt="見積りと決済"
                  className="w-full h-48 object-cover object-top"
                />
              </div>
              
              <div className="w-14 h-14 flex items-center justify-center bg-blue-600 rounded-xl mb-4">
                <i className="ri-money-dollar-circle-line text-2xl text-white"></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                見積りと決済
              </h3>
              <p className="text-gray-600 mb-2">
                最短10分でお見積りをメールでお届け
              </p>
              <p className="text-gray-600">
                選べるお支払い方法（クレジット・請求書払い等）
              </p>
            </div>
          </div>
          
          <div className="relative">
            <div className="relative bg-gradient-to-br from-blue-50 to-white p-8 rounded-2xl border-2 border-blue-100 hover:border-blue-300 transition-all hover:shadow-lg">
              <div className="text-5xl font-bold text-blue-200 mb-4">03</div>
              
              <div className="mb-6 rounded-xl overflow-hidden">
                <img 
                  src="https://www.inforesta.com/lp/image/d5ca3a70c931dd1099e9d8745dbb4767.jpg"
                  alt="ご発注→納品"
                  className="w-full h-48 object-cover object-top"
                />
              </div>
              
              <div className="w-14 h-14 flex items-center justify-center bg-blue-600 rounded-xl mb-4">
                <i className="ri-file-pdf-line text-2xl text-white"></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                ご発注→納品
              </h3>
              <p className="text-gray-600">
                PDFなら最短15分でお届け
              </p>
            </div>
          </div>
        </div>
        
        <div className="text-center">
          <button 
            onClick={onQuoteClick}
            className="group bg-blue-600 text-white px-10 py-4 rounded-xl font-bold text-lg hover:bg-blue-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            <i className="ri-file-list-3-line"></i>
            無料見積もりを依頼する
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
          </button>
        </div>
      </div>
    </section>
  );
}